export class TrackedUnit {
  id: number | null;
  isn: number | null;
  companyPartNumber: string | null;
  manufacturerPartNumber: string | null;
  manufacturerSerialNumber: string | null;
  companySerialNumber: string | null;
  position: string | null;
  aircraftNumberLocation: string | null;
  department: string | null;
  statusFlag: string | null;
  soNbr: string | null;
  soStatus: string | null;
  category: string | null;
  reason: string | null;
  origPosition: string | null;
  origAircraftNumberLocation: string | null;
  origDepartment: string | null;
  origStatus: string | null;
  origSoNbr: string | null;
  origSoStatus: string | null;
  closed: boolean | null;
  alertCount: number | null;
  caseId: number | null;
  starred: boolean | null;
  enteredAt: Date | null;
  enteredBy: string | null;
  updatedAt: Date | null;
  updatedBy: string | null;
  removalAlertIndicator: number | null;
  serviceableAlertIndicator: number | null;
  installationAlertIndicator: number | null;
  locationChangeAlertIndicator: number | null;
  positionChangeAlertIndicator: number | null;
  oneTimeAlertIndicator: number | null;
}
